import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Catalog from "@/pages/Catalog";
import Success from "@/pages/Success";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import WhatsAppWidget from "@/components/WhatsAppWidget";
import axios from "axios";
import { captureAttribution } from "@/lib/attribution";
import GAds from "@/components/GAds";

captureAttribution();

const tenantParam = new URLSearchParams(window.location.search).get("tenant");
if (tenantParam) sessionStorage.setItem("bp_tenant", tenantParam);
// La tienda pública NUNCA usa la selección del switcher del admin (bp_admin_tenant):
// eso es contexto de administración y no debe cambiar lo que ven los clientes.
const storeTenant = tenantParam || sessionStorage.getItem("bp_tenant");
if (storeTenant) axios.defaults.headers.common["X-Tenant"] = storeTenant;

function AdminRoute({ children }) {
  const { token, checking } = useAuth();
  if (checking) return <div className="min-h-screen bg-ink flex items-center justify-center text-zinc-500">Cargando...</div>;
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster
            position="top-center"
            theme="dark"
            toastOptions={{ style: { background: "rgb(var(--c-panel))", border: "1px solid rgb(var(--c-line))", color: "#fff" } }}
          />
          <Routes>
            <Route path="/" element={<Catalog />} />
            <Route path="/promos" element={<Catalog />} />
            <Route path="/pizzas" element={<Catalog />} />
            <Route path="/pizzas/piedra" element={<Catalog />} />
            <Route path="/pizzas/molde" element={<Catalog />} />
            <Route path="/pizzas/xl" element={<Catalog />} />
            <Route path="/empanadas" element={<Catalog />} />
            <Route path="/bebidas" element={<Catalog />} />
            <Route path="/dulces" element={<Catalog />} />
            <Route path="/promo/:slug" element={<Catalog />} />
            <Route path="/exito/:orderId" element={<Success />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminRoute><AdminPanel /></AdminRoute>} />
          </Routes>
          <GAds />
          <WhatsAppWidget />
        </BrowserRouter>
      </CartProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}
